import React, { useEffect } from "react";
import "../general.css";
import "./LoginPage.css";
import logo from "../assets/logo.png";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
  const navigate = useNavigate();

  const year = () => {
    let VarDate = new Date().getFullYear();
    return VarDate;
  };

  useEffect(() => {
    if (sessionStorage.getItem("MainHome") !== null) {
      navigate("/" + sessionStorage.getItem("MainHome"));
      
    }else if (sessionStorage.getItem("UserType") !== null) {
      navigate("/login");
    }   else {
      navigate("/");
    }
  }, [navigate]);
  

  const Student = () => {
    let type = "Student";
    sessionStorage.setItem("UserType", type);
    navigate("/login");
  };

  const Academic_Staff = () => {
    let type = "Academic Staff";

    sessionStorage.setItem("UserType", type);
    navigate("/login");
  };

  const Non_Academic_Staff = () => {
    let type = "Non-Academic Staff";

    sessionStorage.setItem("UserType", type);
    navigate("/login");
  };

  const TableDisplay = () => {
    return (
      <div className="features-section">
        <h2 className="section-title">Document Approval System Features</h2>
        <p className="section-description">
          Streamlined document processing for academic and administrative workflows
        </p>
        
        <table className="login-table">
          <thead>
            <tr>
              <th>Student Portal</th>
              <th>Academic Staff Portal</th>
              <th>Administrative Staff Portal</th>
            </tr>
          </thead>

          <tbody>
            <tr>
              <td>📝 Submit Exam Reschedule Requests</td>
              <td rowSpan={3}>✅ Review & Approve Student Requests</td>
              <td>✅ Process Administrative Approvals</td>
            </tr>

            <tr>
              <td>📝 Submit Exam Re-attempt Requests</td>
              <td>✅ Generate Official Letters</td>
            </tr>

            <tr>
              <td>📝 Submit Lab Reschedule Requests</td>
              <td>✅ Issue Student ID Cards</td>
            </tr>

            <tr>
              <td>📝 Request Studentship Confirmation</td>
              <td rowSpan={2}>✅ Manage Academic Workflows</td>
              <td>✅ Provide Progress Reports</td>
            </tr>

            <tr>
              <td>📝 Request Progress Reports</td>
              <td>✅ Issue Bonafide Certificates</td>
            </tr>

            <tr>
              <td>📝 Request Student ID Card</td>
              <td rowSpan={2}>✅ Approve Lab Reschedules</td>
              <td rowSpan={2}>✅ Process Certificate Requests</td>
            </tr>

            <tr>
              <td>📝 Request Bonafide Certificate</td>
            </tr>
          </tbody>
        </table>
      </div>
    );
  };

  return (
    <div className="main">
      <div className="Background">
        <div className="Header">
          <img src={logo} alt="University Logo" className="Logo" />
          <div className="title">
            VIT Document Approval System
          </div>
        </div>

        <div className="Main-Background">
          <div className="Content-Background">
            <div className="welcome-section">
              <h1 className="welcome-title">Welcome to VIT Document Approval System</h1>
              <p className="welcome-subtitle">
                Efficient, secure, and transparent document processing for the VIT community
              </p>
            </div>

            <TableDisplay />

            <div className="login-section">
              <h3 className="login-title">Access Your Portal</h3>
              <p className="login-description">
                Select your role to access the appropriate portal and manage your documents
              </p>
              
              <div className="buttons-sets">
                <button className="Sign-In-Button" onClick={Student}>
                  <span className="button-icon">🎓</span>
                  <span className="button-text">
                    <strong>Student Portal</strong>
                    <small>Submit requests & track status</small>
                  </span>
                </button>
                
                <button className="Sign-In-Button" onClick={Academic_Staff}>
                  <span className="button-icon">👨‍🏫</span>
                  <span className="button-text">
                    <strong>Academic Staff</strong>
                    <small>Review & approve requests</small>
                  </span>
                </button>
                
                <button className="Sign-In-Button" onClick={Non_Academic_Staff}>
                  <span className="button-icon">👨‍💼</span>
                  <span className="button-text">
                    <strong>Administrative Staff</strong>
                    <small>Process administrative tasks</small>
                  </span>
                </button>
              </div>
            </div>

            <div className="footer-section">
              <p className="footer-text">
                © {year()} GARV ANAND. All rights reserved. | Secure Document Management System
              </p>
              <p className="footer-credit">Developed by GARV ANAND</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginPage;
